var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeclineButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 23,
    viewBox: "0 0 65 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 63.8529,
    height: 21.8529,
    rx: 3.75,
    fill: "#FC68B4",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1381 15.6765V10.7365C13.1381 10.2512 13.0298 9.91318 12.8131 9.72251C12.6051 9.53185 12.3191 9.43651 11.9551 9.43651H8.77011V8.37051H12.3061C12.7394 8.37051 13.1208 8.45285 13.4501 8.61751C13.7881 8.77351 14.0481 9.02918 14.2301 9.38451C14.4208 9.73985 14.5161 10.2122 14.5161 10.8015V15.6765H13.1381ZM8.73111 15.6765V12.1535L8.92611 11.2825H10.1091V12.1535V15.6765H8.73111ZM16.1751 12.9465V11.8675V9.89151L16.0191 8.37051H17.3971L17.5661 9.89151V11.8675L17.5531 12.6865L16.1751 12.9465ZM19.2855 12.9465V11.8675V9.89151L19.1295 8.37051H20.5075L20.6765 9.89151V11.8675L20.6635 12.6865L19.2855 12.9465ZM26.8158 15.6765V10.8665C26.8158 9.91318 26.4215 9.43651 25.6328 9.43651H22.2528V8.37051H25.9838C26.4345 8.37051 26.8245 8.46151 27.1538 8.64351C27.4918 8.82551 27.7475 9.10718 27.9208 9.48851C28.1028 9.86118 28.1938 10.3422 28.1938 10.9315V15.6765H26.8158ZM22.2528 15.6765V8.92951H23.6438V15.6765H22.2528ZM32.7198 15.6765V10.9575C32.7198 10.6195 32.7501 10.3248 32.8108 10.0735C32.8801 9.81351 32.9711 9.60118 33.0838 9.43651H29.5738V8.37051H35.3718V9.43651H34.3838C34.2711 9.65318 34.1931 9.90451 34.1498 10.1905C34.1151 10.4678 34.0978 10.7235 34.0978 10.9575V15.6765H32.7198Z",
    fill: "#FC68B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7648 6.58826L42.5884 15.7647M42.5884 6.58826L51.7648 15.7647",
    stroke: "#FC68B4",
    strokeWidth: 1.14706,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 63.8529,
    height: 21.8529,
    rx: 3.75,
    stroke: "#FC68B4",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineButton);
export default __webpack_public_path__ + "static/media/declineButton.0a09e68b38559a4ba3fb932c1040121e.svg";
export { ForwardRef as ReactComponent };